import { TArrayOfThree } from '.';

/**
 * Склонения для года
 *
 * @return ['год', 'года', 'лет']
 */
export const yearPluralize: TArrayOfThree = ['год', 'года', 'лет'];

/**
 * Склонения для месяца
 *
 * @return ['месяц', 'месяца', 'месяцев']
 */
export const monthPluralize: TArrayOfThree = ['месяц', 'месяца', 'месяцев'];

/**
 * Склонения для дня
 *
 * @return ['день', 'дня', 'дней']
 */
export const dayPluralize: TArrayOfThree = ['день', 'дня', 'дней'];

/**
 * Склонения для канала
 *
 * @return ['канал', 'канала', 'каналов']
 */
export const channelPluralize: TArrayOfThree = ['канал', 'канала', 'каналов'];

/**
 * Склонения для бонуса
 *
 * @return ['бонус', 'бонуса', 'бонусов']
 */
export const bonusPluralize: TArrayOfThree = ['бонус', 'бонуса', 'бонусов'];

/**
 * Склонения для рубля
 *
 * @return ['рубль', 'рубля', 'рублей']
 */
export const rublePluralize: TArrayOfThree = ['рубль', 'рубля', 'рублей'];
